import React from "react";
import iBPMS from "../Assets/Images/iBPMSDetails.png";
import { Link } from "react-router-dom";
import { LinkedinShareButton, TwitterShareButton } from "react-share";
import twitter from "../Assets/Images/twitter.svg";
import linkedin from "../Assets/Images/linkedin.svg";

const IBPMS = () => {
  const shareUrl = "https://designx.in/iBPMS";
  const title = "iBPMS";
  return (
    <div className="blogback">
      <div className="blogHeaderBack pt-[75px]">
        <div className="block lg:grid lg:grid-cols-2 gap-4 relative z-[1]">
          <div className="mx-[30px] md:mx-[50px] xl:mx-[80px] py-[20px]">
            <p className="text-white text-[14px] lg:text-[18px] font-inter mt-[31px]">
              <Link to="/" className="homeButton">
                Home
              </Link>{" "}
              /{" "}
              <Link to="/Blogs" className="homeButton">
                Blog
              </Link>
            </p>
            <p className="text-white text-[22px] md:text-[32px] xl:text-[42px] font-robotoSlab">
              How DFOS empowers intelligent business process management
              suite(iBPMS)?
            </p>
            <p className="text-[14px] lg:text-[17px] text-white font-poppins font-normal">
              Leverage the benefits of Intelligent Business Process Management
              suite
            </p>
          </div>
          <div className="hidden lg:flex lg:justify-end">
            <img src={iBPMS} alt="" />
          </div>
        </div>
      </div>
      <div className="mx-[30px] md:mx-[50px] xl:mx-[80px] mt-[52px] pb-[50px]">
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          In the modern world today, where we walk besides technology, iBMP
          (Intelligent Business Process Management) can be an appealing solution
          for your business. From handling complicated business operations to
          entirely automating your shopfloors, it can help you gain a
          competitive edge. But, how DFOS allows you to perform intelligent
          business process management suite? DFOS is an efficient & effective
          platform, which is currently transforming the way industries are
          managing their business operations, resources, data and so forth with
          the assistance of iBPMS, IIOT, RPA & AI.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          Today we will find how DFOS empowers iBPM; but before that let us peep
          into the meaning of iBMP.{" "}
        </p>

        <p className="text-[#FCFCFC] text-[20px] md:text-[24px] lg:text-[28px] mt-[40px] font-poppins font-medium">
          What is intelligent business process management suite?
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          Business process management is an effective method to evaluate entire
          process, however, intelligent business process management took us one
          step ahead by combining Artificial Intelligence (AI). IBPMS is an
          entire software that combines different functionalities to automate
          and optimize critical business operations. It helps businesses build
          end-to-end solutions, enhance workflow experience and create dynamic
          processes with the assistance of AI, MI, data analytics, cloud-based
          platforms and related tools.{" "}
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          From intelligent decision making to driving operational efficiency,
          intelligent business process management suite can assist a business in
          multiple departments. Some of the key features of iBPMS are as
          follows:{" "}
        </p>
        <ul
          className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins"
          style={{ listStyleType: "disc" }}
        >
          <li>
            It helps businesses in process automation as it automates manual
            tasks, which are repetitive in nature to minimize human errors.
            Also, employees can focus on more strategic activities to ensure
            business processes can be streamlined effectively.
          </li>
          <li>
            Data management is another key feature of iBPMS. It can seamlessly
            consolidate data from multiple sources to provide the entire view of
            the business.
          </li>
          <li>
            IBPMs can provide real-time business analysis, which helps in taking
            real-time decisions based on data analyses.
          </li>
        </ul>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          So, these are some of the key features of IBPMS. Now you must be
          thinking how DesignX’s platform- DFOS can help you with iBPMS? Let us
          find out.
        </p>
        <p className="text-[#FCFCFC] text-[20px] md:text-[24px] lg:text-[28px] mt-[40px] font-poppins font-medium">
          How DFOS empowers shop floors with iBPMS?
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          Today, several brands offer compelling options for businesses looking
          to optimize their operations and drive growth. But IBPMS solutions by
          DFOS stand out for businesses & prove itself a strategic choice. How?
          Let’s find out!
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          With a focus on cutting-edge features, industry expertise, and a track
          record of delivering tangible results, DFOS is a powerful platform to
          transform shop floors into efficient, agile, and smart shop floors.
          Additionally, we cater to multiple industry needs, which gives us an
          edge over others. Here is one another catch! With our platform, you
          can analyze your manufacturing hub’s performance with a wide spectrum
          and ensure that there is no wastage of resources.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins">
          DFOS empowers your shop floor with various solutions including IBMPS,
          AI, RPA and so forth. However, you can select solutions which are
          relevant to your business.
        </p>

        <p className="text-[#FCFCFC] text-[20px] md:text-[24px] lg:text-[28px] mt-[40px] font-medium">
          Why is DFOS the best choice for manufacturing units?
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          Being a DIY platform, DFOS is a perfect choice if you are looking for
          smart manufacturing solutions. With it, you can create a tailor-made
          strategy for your shop floor & expand with automation. In addition,
          DesignX gives you end-to-end digitalization solutions for your
          manufacturing unit. Our platform is empowered with an intelligent
          business process management suite and many other solutions, which
          together can help you switch to automation.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          Let us look at some of the benefits of choosing iBPMS solution of
          DFOS:
        </p>

        <p className="text-[#FCFCFC] text-[16px] md:text-[20px] lg:text-[24px] mt-[40px] font-poppins font-medium">
          More Efficiency
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          The key strength of our platform is to provide unique & tailor-made
          solutions with an ultra-modern approach. Our platform is highly
          effective and efficient in providing a holistic view of business.
          Also, we have years of expertise in working with diverse businesses
          across multiple sectors. This expertise assists us optimizing our
          platform to address specific needs by delivering topnotch solutions.
        </p>

        <p className="text-[#FCFCFC] text-[16px] md:text-[20px] lg:text-[24px] mt-[40px] font-poppins font-medium">
          Scope for Scalability
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          No more limited solutions! Yes, our platform gives you multiple
          services at one space. From automating your shop floor to creating a
          digital twin, we give you all-in-one solutions. This gives you a
          higher scope for scalability as you have one trustworthy source which
          can give you automation & smart manufacturing solutions in one go!
        </p>

        <p className="text-[#FCFCFC] text-[16px] md:text-[20px] lg:text-[24px] mt-[40px] font-poppins font-medium">
          DIY platform- Best in Industry
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          We provide you with the best in industry solutions that are created by
          our team of tech experts. With DFOS, you can choose only relevant
          solutions for your business. It will help you in eliminating
          additional expenses and you can easily transform your shop floor
          smartly.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          With our platform, you can reap the benefits of Industry 4.0 and be
          one step closer to becoming a completely automated shop floor. So go
          digital with DFOS!.
        </p>

        <p className="text-[#FCFCFC] text-[20px] md:text-[24px] lg:text-[28px] mt-[40px] font-poppins font-medium">
          The Bottom Line
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify font-medium">
          Switching to smart manufacturing is no longer a choice, if you want to
          stay ahead of your competitors. In the era of digitalization &
          automation, intelligent business process management suite is a crucial
          tool that can help a manufacturing unit optimize their operations,
          attain sustainable growth & enhance their real-time decision making.
          So, get DFOS empowered IBPMS solutions that will work as a backbone of
          your manufacturing hub by providing you smart manufacturing solutions.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          Furthermore, digitalization & automation of manufacturing units is the
          reality of the future, so it's better to adapt to today.
        </p>
        <p className="text-[#C8C8C8] text-[14px] lg:text-[18px] font-poppins text-justify">
          Pre-create the future manufacturing unit with DesignX.
        </p>
      </div>
      <div className="fixed bottom-[170px] right-4 z-12">
        <TwitterShareButton url={shareUrl} title={title}>
          <img src={twitter} className="w-[45px] h-[45px]" alt="twitter" />
        </TwitterShareButton>
      </div>
      <div className="fixed bottom-[120px] right-4 z-12">
        <LinkedinShareButton url={shareUrl} title={title}>
          <img src={linkedin} className="w-[45px] h-[45px]" alt="linkedin" />
        </LinkedinShareButton>
      </div>
    </div>
  );
};

export default IBPMS;
